import type { SVGProps } from '@/types/common.types';

const WinkSecondarySVG = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="16"
      viewBox="0 0 50 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_11728_19144)">
        <path
          d="M14.9033 2.46484H16.9762L18.6316 9.05503C18.6316 9.05503 18.8111 9.81532 18.8855 10.1889C18.96 9.81675 19.1395 9.0404 19.1395 9.0404L20.8401 2.46484H22.8692L24.5698 9.0404C24.5698 9.0404 24.7493 9.81532 24.8238 10.1889C24.8983 9.81675 25.0778 9.05503 25.0778 9.05503L26.7332 2.46484H28.806L25.9274 12.9017H23.8093L21.8561 5.32798L19.903 12.9017H17.7849L14.9033 2.46484Z"
          fill="currentColor"
        />
        <path d="M31.8826 5.5061H30.0039V12.9018H31.8826V5.5061Z" fill="currentColor" />
        <path
          d="M38.8728 12.9017V8.63769C38.8728 7.66872 38.4101 7.05729 37.3664 7.05729C36.3825 7.05729 35.6512 7.9066 35.6512 9.14409V12.9017H33.7725V5.50604H35.6512V6.69826C36.2029 5.849 37.0832 5.29736 38.1561 5.29736C39.737 5.29736 40.7515 6.32615 40.7515 7.86135V12.9003H38.8728V12.9017Z"
          fill="currentColor"
        />
        <path
          d="M42.4385 2.46484H44.3172V7.74309L46.5696 5.50601H48.8964L46.1974 8.1444L49.2555 12.9002H47.0921L44.8851 9.44172L44.3187 9.99332V12.9002H42.44V2.46484H42.4385Z"
          fill="currentColor"
        />
        <path
          d="M29.7539 1.70166L30.4881 2.43568L29.7539 3.16971L30.6225 4.03653L32.2238 2.43568L30.6225 0.834839L29.7539 1.70166Z"
          fill="currentColor"
        />
        <path
          d="M4.19385 0L0 4.19255L3.54864 7.74011L0 11.2891L4.19385 15.4817L11.9378 7.74011L4.19385 0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_11728_19144">
          <rect width="49.7297" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WinkSecondarySVG;
